import router from '@/router/index.router';
import useSelfService from './SelfService';
import { isArray } from 'lodash-es';

class NavigationGuardService {
	private get self () { return useSelfService().self; }

	checkPermissionAndRedirect (permissions: PermissionGuard | PermissionGuard[], cb?: Function | string) {
		if (isArray(permissions) && this.self.canAllOf(...permissions)) {
			return true;
		} else if (!isArray(permissions) && this.self.can(permissions)) {
			return true;
		} else {
			if (typeof cb === 'function') {
				cb();
			} else if (typeof cb === 'string') {
				router.push({ name: cb });
			} else {
				router.push('/');
			}
			return false;
		}
	}
}

const navigationGuardServiceSingleton = new NavigationGuardService();

// eslint-disable-next-line no-unused-vars
export default function useNavigationGuardService (permissions: PermissionGuard | PermissionGuard[], cb?: Function | string): boolean;
export default function useNavigationGuardService (): NavigationGuardService;
export default function useNavigationGuardService (
	permissions?: PermissionGuard | PermissionGuard[],
	cb?: Function | string,
): NavigationGuardService | boolean {
	if (!!permissions) return navigationGuardServiceSingleton.checkPermissionAndRedirect(permissions, cb);
	return navigationGuardServiceSingleton;
}
